export const app = {
  actions: {
    setPageTitle: (_, title) => {
      if (typeof title === 'string' && title !== '') {
        document.title = title
      } else if (title === '' || document.title === '') {
        document.title = window.config.TITLE
      }
    }
  }
}
